<div class="select-org-container">
  <ng-container *ngIf="!!myOrganisations; else noOrgsTemplate">
    <div class="search-section" *ngIf="myOrganisations.length > 1">
      <mat-form-field appearance="outline" class="search-field">
        <mat-label>{{ 'general.search' | translate }}</mat-label>
        <mat-icon matPrefix>search</mat-icon>
        <input #searchField matInput [(ngModel)]="currentSearchTerm" (ngModelChange)="filterOrganisations(currentSearchTerm)" placeholder="Search by name..."/>
        <button mat-icon-button matSuffix *ngIf="currentSearchTerm" (click)="currentSearchTerm=''; searchField.value=''; filterOrganisations('')" aria-label="Clear">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </div>
    <div *ngIf="filteredOrganisations && filteredOrganisations.length; else noResultsTemplate">
      <div *ngIf="currentSearchTerm?.trim()?.length; else groupedLayout" class="card-grid">
        <mat-card *ngFor="let organisation of filteredOrganisations" class="org-card" appearance="outlined" (click)="selectOrganisation(organisation)">
          <div class="card-content">
            <div class="org-icon">
              <mat-icon>{{ getIcon(organisation) }}</mat-icon>
            </div>
            <div class="org-details">
              <span class="org-title">{{ organisation.title }}</span>
            </div>
            <mat-icon class="arrow-icon" [class.active]="isBookmarked(organisation)"
                      (click)="toggleBookmark(organisation, $event)">{{ isBookmarked(organisation) ? 'star' : 'star_border' }}</mat-icon>
          </div>
        </mat-card>
      </div>
      <ng-template #groupedLayout>
        <div class="org-sections">
          <ng-container *ngIf="sortedOrganisations?.['bookmarked']?.length">
            <div class="card-grid">
              <mat-card *ngFor="let organisation of sortedOrganisations['bookmarked']" class="org-card static-card" appearance="outlined" (click)="selectOrganisation(organisation)">
                <div class="card-content">
                  <div class="org-icon">
                    <mat-icon>domain</mat-icon>
                  </div>
                  <div class="org-details">
                    <span class="org-title">{{ organisation.title }}</span>
                  </div>
                  <mat-icon class="arrow-icon" [class.active]="isBookmarked(organisation)"
                            (click)="toggleBookmark(organisation, $event)">{{ isBookmarked(organisation) ? 'star' : 'star_border' }}</mat-icon>
                </div>
              </mat-card>
            </div>
          </ng-container>
          <ng-container *ngFor="let tag of organisationTags">
            <div *ngIf="sortedOrganisations?.[tag]?.length" class="tag-group">
              <mat-expansion-panel class="custom-panel" flat>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <span class="panel-label">{{ 'organisation.tag.' + tag | translate }}</span>
                    <span class="count-badge light">{{ sortedOrganisations[tag].length }}</span>
                  </mat-panel-title>
                </mat-expansion-panel-header>

                <div class="card-grid panel-grid">
                  <mat-card *ngFor="let organisation of sortedOrganisations[tag]" class="org-card" appearance="outlined" (click)="selectOrganisation(organisation)">
                    <div class="card-content">
                      <div class="org-icon">
                        <mat-icon>{{ getIcon(organisation) }}</mat-icon>
                      </div>
                      <div class="org-details">
                        <span class="org-title">{{ organisation.title }}</span>
                      </div>
                      <mat-icon class="arrow-icon" [class.active]="isBookmarked(organisation)"
                                (click)="toggleBookmark(organisation, $event)">{{ isBookmarked(organisation) ? 'star' : 'star_border' }}</mat-icon>
                    </div>
                  </mat-card>
                </div>
              </mat-expansion-panel>
            </div>
          </ng-container>
        </div>
      </ng-template>
    </div>
    <ng-template #noResultsTemplate>
      <div class="empty-state">
        <mat-icon class="empty-icon">search_off</mat-icon>
        <p class="empty-text">{{ 'organisation.noResult' | translate }}</p>
      </div>
    </ng-template>
  </ng-container>
  <ng-template #noOrgsTemplate>
    <div class="empty-state hero-empty">
      <mat-icon class="empty-icon">corporate_fare</mat-icon>
      <h2>{{ 'organisation.noOrgTitle' | translate }}</h2>
      <p>{{ 'organisation.noOrgMessage' | translate }}</p>
      <a [href]="'mailto:' + supportMail" mat-flat-button color="primary">
        <mat-icon>mail</mat-icon>
        {{ 'organisation.sendMail' | translate }}
      </a>
    </div>
  </ng-template>
</div>
